<script setup lang="ts">
  import { onMounted, onUnmounted, computed } from 'vue'
  const emit = defineEmits(['close'])
  function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') emit('close')
  }
  onMounted(() => window.addEventListener('keydown', onKeydown))
  onUnmounted(() => window.removeEventListener('keydown', onKeydown))
  const secondaryCtaClass = computed(() => 'your-secondary-class')
  const primaryCtaClass = computed(() => 'your-primary-class')
</script>

<template>
  <div class="fixed inset-x-0 top-16 bottom-0 z-40 bg-black bg-opacity-70" @click="$emit('close')"></div>
  <div class="fixed inset-x-0 bg-white z-50 flex flex-col py-4" @click.stop>
    <RouterLink to="/home"
      class="text-body1 flex items-center px-6 h-14 hover:bg-gray-200 border-transparent transition-all">
      Home
    </RouterLink>
    <RouterLink to="/about"
      class="text-body1 flex items-center px-6 h-14 hover:bg-gray-200 border-transparent transition-all">
      About Us
    </RouterLink>
    <RouterLink to="/faq"
      class="text-body1 flex items-center px-6 h-14 hover:bg-gray-200 border-transparent transition-all">
      FAQ
    </RouterLink>
    <RouterLink to="/contact"
      class="text-body1 flex items-center px-6 h-14 hover:bg-gray-200 border-transparent transition-all">
      Contact
    </RouterLink>

    <div class="mx-6 py-4">
      <div class="my-4 transition-all duration-200">
        <RouterLink to="/login">
          <Button :class="secondaryCtaClass"
            class="transition-all text-body1 border border-gray-300 hover:border-gray-500 hover:bg-gray-100 w-full rounded-full px-4 py-2">Login</Button>
        </RouterLink>
      </div>

      <div class="my-4 transition-all duration-200">
        <RouterLink to="/signup">
          <Button :class="primaryCtaClass"
            class="transition-all text-body1 border border-black text-white bg-black hover:bg-gray-900 w-full rounded-full px-4 py-2">Get
            Started</Button>
        </RouterLink>
      </div>
    </div>
    <!-- Add more links -->
  </div>
</template>
